import React from 'react';

/**
 * The clear (✕) end icon in an applied-filter / applied-customization pill.
 *
 * Every property overrides a `.EndIcon` declaration in `Button.module.scss`, which is why this
 * lives beside Button rather than in any one caller. `width` is the only new property: the ✕
 * glyph preserves its aspect ratio, so `.EndIcon`'s `1rem` width only letterboxed it with
 * transparent padding either side, and setting `width` tightens the box around it. `marginLeft`
 * is unchanged — every call site already passed `0.25rem`.
 *
 * Only a string `endIcon` needs it — a JSX one carries its own intrinsic size (see `CrossIcon`).
 */
export const SQUARE_END_ICON_STYLE: React.CSSProperties = {
    height: '0.8rem',
    width: '0.8rem',
    marginLeft: '0.25rem',
};
